import * as React from 'react';
import { Dialog } from 'primereact/dialog';
import { Button } from "primereact/button";
import AtcCodeService from '../../../services/atcCodeService';
import { DataTable } from 'primereact/datatable';
import { Column } from 'primereact/column';
import { ATCCodeModel, ATCCodeGridModel, ATCCodeFilterSettingsModel } from "../../../models/atcCode";
import { Toolbar } from 'primereact/toolbar';
import { InputText } from 'primereact/inputtext';

interface IProps {
  isVisible: boolean,
  cancelClick: any,
  addClick: any,
  selectedATCCode: ATCCodeModel | undefined
}

interface IState {
  isLoading: boolean;
  error: any;
  atcCodes: Array<ATCCodeModel>
  currentATCCode: ATCCodeModel | undefined;
  from: number;
  numberOfRows: number;
  totalRecordsCount: number;
  currentFilterSettings: ATCCodeFilterSettingsModel
}

const initFrom = 0;
const numberOfRows = 10;

class AtcCodeListDialog extends React.Component<IProps, IState> {

  atcCodeService = new AtcCodeService();

  constructor(props: IProps) {
    super(props);

    this.state = {
      isLoading: false,
      error: null,
      from: initFrom,
      numberOfRows: numberOfRows,
      totalRecordsCount: 0,
      atcCodes: new Array<ATCCodeModel>(),
      currentATCCode: this.props.selectedATCCode,
      currentFilterSettings: new ATCCodeFilterSettingsModel()
    }
  }

  componentDidMount() {
    this.getAllFilteredItems(this.state.from, this.state.numberOfRows, this.state.currentFilterSettings);
  }

  getAllFilteredItems(from: number, numberOfRows: number, currentFilterSettings: ATCCodeFilterSettingsModel) {
    this.setState({
      isLoading: true
    });

    this.atcCodeService.getAllFilteredItems(from, numberOfRows, currentFilterSettings).then(
      (data: ATCCodeGridModel) => {
        this.setState({
          isLoading: false,
          from: from,
          atcCodes: data.atcCodes,
          totalRecordsCount: data.totalRecordsCount
        });
      })
      .catch(error => {
        this.setState({
          isLoading: false,
          error
        });
      });
  }

  handleOnPageClick = (e) => {
    const startIndex = e.first;
    this.getAllFilteredItems(startIndex, this.state.numberOfRows, this.state.currentFilterSettings);
  }

  handleAddButton = event => {
    event.preventDefault();
    const currentATCCode = this.state.currentATCCode;
    this.props.addClick(currentATCCode);
  }

  handleCancelButton = () => {
    this.props.cancelClick();
  }

  handleFilterChange = (event) => {
    const target = event.target;
    const value = target.type === 'checkbox' ? target.checked : target.value
    const name = target.name;

    const currentFilterSettings: ATCCodeFilterSettingsModel = { ...this.state.currentFilterSettings };
    currentFilterSettings[name] = value;
    this.setState({
      currentFilterSettings: { ...currentFilterSettings }
    });
  }

  handleFilterButtonClick = (settings) => {
    this.getAllFilteredItems(this.state.from, this.state.numberOfRows, settings);
  }

  handleClearButtonClick = () => {
    this.setState({
      currentFilterSettings: new ATCCodeFilterSettingsModel()
    });

    this.handleFilterButtonClick(new ATCCodeFilterSettingsModel());
  }

  getTitle = (atcCode: ATCCodeModel) => {
    return atcCode.atcCodeContent && atcCode.atcCodeContent.length > 0 ? atcCode.atcCodeContent.map(r => r.atcCodeName).join(' / ') : null
  }

  displayHeaderSelection(currentATCCode: ATCCodeModel | undefined) {
    if (!currentATCCode || (currentATCCode && !currentATCCode.atcCode)) {
      return <div style={{ textAlign: 'left' }}>No Selection</div>;
    }
    else {
      return <div style={{ textAlign: 'left' }}>Selected ATC Code: {currentATCCode.atcCode + ' / ' +
        this.getTitle(currentATCCode)}</div>
    }
  }

  handleKeyPress = (e) => {
    if (e.key === 'Enter') {
      this.handleFilterButtonClick(this.state.currentFilterSettings)
    }
  }

  //TODO: Add cinst for objects so to not use full this.state....
  render() {
    return (
      <Dialog header="ATC Codes" responsive={true} width="60%"
        modal={true}
        visible={this.props.isVisible}
        onHide={this.handleCancelButton}
        footer={
          <div>
            <Button label="Add" icon="pi pi-check" onClick={this.handleAddButton} className="p-button-raised" />
            <Button label="Cancel" icon="pi pi-times" onClick={this.handleCancelButton} className="p-button-secondary p-button-raised" />
          </div>
        }>
        <Toolbar style={{ marginBottom: '10px' }}>
          <div>
            <div className="p-grid p-fluid p-md-12">
              <div className="p-col-12 p-md-6">
                <InputText
                  width="200px"
                  onKeyPress={(e) => this.handleKeyPress(e)}
                  name="atcCode"
                  placeholder="ATC Code"
                  onChange={this.handleFilterChange}
                  value={this.state.currentFilterSettings && this.state.currentFilterSettings.atcCode ? this.state.currentFilterSettings.atcCode : ''}
                />
              </div>
              <div className="p-col-12 p-md-6">
                <InputText
                  name="atcName"
                  placeholder="ATC Name"
                  onKeyPress={(e) => this.handleKeyPress(e)}
                  onChange={this.handleFilterChange}
                  value={this.state.currentFilterSettings && this.state.currentFilterSettings.atcName ? this.state.currentFilterSettings.atcName : ''}
                />
              </div>
            </div>
            <div style={{ float: "right" }}>
              <div className="p-grid p-fluid p-md-12">
                <div className="p-col-12 p-md-6" >
                  <Button
                    className="p-button-raised"
                    icon="pi pi-filter"
                    label="Filter"
                    onClick={() => this.handleFilterButtonClick(this.state.currentFilterSettings)}
                  />
                </div>
                <div className="p-col-12 p-md-6" style={{ float: "right" }}>
                  <Button
                    className="p-button-secondary p-button-raised"
                    label="Clear"
                    icon="pi pi-times"
                    onClick={() => this.handleClearButtonClick()}
                  />
                </div>
              </div>
            </div>
          </div>
        </Toolbar >
        <div style={{ minHeight: '400px', maxHeight: '550px', overflowY: 'auto' }}>
          <DataTable
            value={this.state.atcCodes}
            paginator={true}
            lazy={true}
            rows={this.state.numberOfRows}
            first={this.state.from}
            selectionMode="single"
            selection={this.state.currentATCCode}
            header={this.displayHeaderSelection(this.state.currentATCCode)}
            totalRecords={this.state.totalRecordsCount}
            onPage={(event) => this.handleOnPageClick(event)}
            onSelectionChange={(e) => this.setState({ currentATCCode: e.data })}>
            <Column selectionMode="single" style={{ width: '3em' }} />
            <Column field="atcCode" header="ATC Code" />
            <Column header="ATC Name BG"
              body={(rowData, column) => rowData.atcCodeContent && rowData.atcCodeContent.length > 0 ? rowData.atcCodeContent[0].atcCodeName : null
              }
            />
            <Column header="ATC Name EN"
              body={(rowData, column) => rowData.atcCodeContent && rowData.atcCodeContent.length > 1 ? rowData.atcCodeContent[1].atcCodeName : null
              } />
          </DataTable>
        </div>
      </Dialog >
    )
  }

}

export default AtcCodeListDialog;

{/* <Toolbar style={{ marginBottom: '10px' }}>
<div>
  <InputText
    style={{ marginRight: "10px", marginBottom: "5px" }}
    name="atcCode"
    placeholder="ATC Code"
    onChange={this.handleFilterChange}
    value={this.state.currentFilterSettings && this.state.currentFilterSettings.atcCode ? this.state.currentFilterSettings.atcCode : ''}
  />
  <InputText
    name="atcName"
    placeholder="ATC Name"
    style={{ marginRight: "10px", marginBottom: "5px" }}
    onChange={this.handleFilterChange}
    value={this.state.currentFilterSettings && this.state.currentFilterSettings.atcName ? this.state.currentFilterSettings.atcName : ''}
  />
</div>
<div style={{ float: "right" }}>
  <div>
    <Button
      className="p-button-raised"
      icon="pi pi-filter"
      style={{ marginRight: "10px" }}
      label="Filter"
      onClick={() => this.handleFilterButtonClick(this.state.currentFilterSettings)}
    />
    <Button
      className="p-button-secondary p-button-raised"
      label="Clear"
      icon="pi pi-times"
      onClick={() => this.handleClearButtonClick()}
    />
  </div>
</div>
</Toolbar> */}